import { environment } from '../environments/environment';

export const SEARCH_DEBOUNCE_TIME = 600;
export const STATUS_CODE_SUCCESS = 200;

const refreshTokenConst = '/user/refreshToken';
const userLogoutConst = '/user/logout';
export const appValueConst = '/appvalue';
const settingConst = '/user/setting';

export const RefreshTokenServicePathConst = `${environment.api.apiV1}${refreshTokenConst}`;
export const UserLogoutServicePathConst = `${environment.api.apiV1}${userLogoutConst}`;
export const AppValueServicePathConst = `${environment.api.apiV1}${appValueConst}`;
export const SessionServicePathConst = `${environment.api.apiV1}${settingConst}`;

// Format Datepicker
export const DATE_PICKER_FORMATS = {
	parse: {
		dateInput: ['DD-MM-YYYY'],
	},
	display: {
		dateInput: 'MM - DD - YYYY',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};